<template>
  <div class="pdf">
    <vue-html2pdf
      style="width: 100%; height: 100%"
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
      :filename="
        'Doccia Group - ' + Coleccion.GetLiteral(Language).toLowerCase()
      "
    >
      <section slot="pdf-content" ref="pdfContent">
        <div class="pdf__header">
          <div class="pdf__header__info">
            <img
              crossOrigin="anonymous"
              @dblclick="ExportExcel()"
              src="@/assets/Images/Global/Logo.svg"
              alt=""
              class="pdf__header__info__logo"
            />
            <div class="pdf__header__info__separator"></div>
            <p class="pdf__header__info__collection">
              {{ Coleccion.GetLiteral(Language).toLowerCase() }}
            </p>
            <p class="pdf__header__info__configuration">
              {{
                aplicacion.tipo == "configurable"
                  ? aplicacion.languageSel == "es"
                    ? "Configuración Personalizada"
                    : aplicacion.languageSel == "en"
                    ? "Custom Configuration"
                    : aplicacion.languageSel == "fr"
                    ? "Configuration Personnalisée"
                    : aplicacion.languageSel == "de"
                    ? "Benutzerdefinierte Konfiguration"
                    : aplicacion.languageSel == "it"
                    ? "Configurazione Personalizzata"
                    : ""
                  : aplicacion.languageSel == "es"
                  ? "Configuración Estándar"
                  : aplicacion.languageSel == "en"
                  ? "Standard Configuration"
                  : aplicacion.languageSel == "fr"
                  ? "Configuration Standard"
                  : aplicacion.languageSel == "de"
                  ? "Standardkonfiguration"
                  : aplicacion.languageSel == "it"
                  ? "Configurazione Standard"
                  : ""
              }}
            </p>
          </div>
          <div class="pdf__header__data">
            <div class="pdf__header__data__item">
              {{ Price.direccion }}
            </div>
            <div class="pdf__header__data__item">
              {{ Price.codigoPostal }} - {{ Price.localidad }}
            </div>
            <div class="pdf__header__data__item">
              {{ Price.email }}
            </div>
            <div class="pdf__header__data__item">
              {{ Price.telefono }}
            </div>
          </div>
        </div>
        <div class="pdf__image">
          <Pricing
            v-if="viewprice"
            :aplicacion="aplicacion"
            :sideSel="aplicacion.coleccionSel.sideSel.Live"
            :token="token"
            :privada="privada"
            :noButton="true"
            @montaje="setMontaje"
          />
          <div class="pdf__image__images">
            <img
              v-for="(image, imageIndex) in images"
              :key="imageIndex"
              :src="
                require('@/assets/Images/Colecciones/1000/' +
                  aplicacion.coleccionSel.codImage +
                  '/' +
                  image)
              "
              alt=""
              class="pdf__image__images__image"
            />
          </div>
        </div>
        <div class="pdf__content">
          <div class="pdf__content__column">
            <div
              class="pdf__content__column__campo"
              style="border-bottom: 1px solid black"
            >
              <h1 class="pdf__content__column__campo__title">
                {{
                  this.aplicacion.coleccionSel.sideSel.Live.GetGrupo("MEDIDAS")
                    .cod
                }}
              </h1>
              <div
                v-for="(
                  Campo, CampoIndex
                ) in this.aplicacion.coleccionSel.sideSel.Live.GetGrupo(
                  'MEDIDAS'
                ).campos"
                v-if="
                  Campo.Resolve(aplicacion.coleccionSel.sideSel.Delay.perfil) &&
                  Campo.visible &&
                  !(
                    Campo.cod == 'TIPO_VIDRIO' && Campo.acabadoSel.cod == '04'
                  ) &&
                  !(Campo.cod == 'COLOR_DECORADO' && Campo.tipo != 'filtro') &&
                  !(
                    Campo.cod == 'COLOR_PERFIL_ST' &&
                    Campo.acabadoSel.cod == 'RL'
                  )
                "
                class="pdf__content__column__campo__caracteristica"
              >
                <div class="pdf__content__column__campo__caracteristica__title">
                  {{ Campo.GetLiteral(aplicacion.languageSel) }}
                </div>
                <div class="pdf__content__column__campo__caracteristica__right">
                  <p
                    v-if="Campo.tipo == 'input'"
                    class="pdf__content__column__campo__caracteristica__right__value"
                  >
                    {{ Campo.value }}
                    <span v-if="Campo.medida != undefined"> mm</span>
                  </p>
                  <p
                    v-else-if="
                      Campo.tipo == 'tacos' ||
                      Campo.tipo == 'dropdown' ||
                      Campo.tipo == 'toggle'
                    "
                    class="pdf__content__column__campo__caracteristica__right__value"
                  >
                    {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                  </p>
                  <div
                    class="pdf__content__column__campo__caracteristica__right__miniatura"
                    v-if="Campo.tipo == 'tacos'"
                  >
                    <img
                      crossOrigin="anonymous"
                      :src="
                        RequireImage(
                          'Tacos',
                          aplicacion.coleccionSel.sideSel.Live.GetTaco(
                            Campo,
                            Campo.acabadoSel
                          )
                        )
                      "
                      alt=""
                      class="pdf__content__column__campo__caracteristica__right__miniatura__image"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="pdf__content__column__campo"
              style="border-bottom: 1px solid black"
            >
              <h1 class="pdf__content__column__campo__title">
                {{
                  this.aplicacion.coleccionSel.sideSel.Live.GetGrupo("VIDRIO")
                    .cod
                }}
              </h1>
              <div
                v-for="(
                  Campo, CampoIndex
                ) in this.aplicacion.coleccionSel.sideSel.Live.GetGrupo(
                  'VIDRIO'
                ).campos"
                v-if="
                  Campo.Resolve(aplicacion.coleccionSel.sideSel.Delay.perfil) &&
                  Campo.visible &&
                  !(
                    Campo.cod == 'TIPO_VIDRIO' && Campo.acabadoSel.cod == '04'
                  ) &&
                  !(Campo.cod == 'COLOR_DECORADO' && Campo.tipo != 'filtro') &&
                  !(
                    Campo.cod == 'COLOR_PERFIL_ST' &&
                    Campo.acabadoSel.cod == 'RL'
                  )
                "
                class="pdf__content__column__campo__caracteristica"
              >
                <div class="pdf__content__column__campo__caracteristica__title">
                  {{ Campo.GetLiteral(aplicacion.languageSel) }}
                </div>
                <div class="pdf__content__column__campo__caracteristica__right">
                  <p
                    v-if="Campo.tipo == 'input'"
                    class="pdf__content__column__campo__caracteristica__right__value"
                    style="position: absolute; right: 100px"
                  >
                    {{ Campo.value }}
                  </p>
                  <p
                    v-else-if="
                      Campo.tipo == 'tacos' ||
                      Campo.tipo == 'dropdown' ||
                      Campo.tipo == 'toggle'
                    "
                    class="pdf__content__column__campo__caracteristica__right__value"
                    style="position: absolute; right: 100px"
                  >
                    {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                  </p>
                  <p
                    v-else-if="Campo.tipo == 'filtro'"
                    class="pdf__content__column__campo__caracteristica__right__value"
                    style="position: absolute; right: 100px"
                  >
                    {{
                      Campo.filtroSel.Live.acabadoSel.GetLiteral(
                        aplicacion.languageSel
                      )
                    }}
                  </p>
                  <div
                    class="pdf__content__column__campo__caracteristica__right__miniatura"
                    v-if="Campo.tipo == 'tacos'"
                  >
                    <img
                      crossOrigin="anonymous"
                      :src="
                        RequireImage(
                          'Tacos',
                          aplicacion.coleccionSel.sideSel.Live.GetTaco(
                            Campo,
                            Campo.acabadoSel
                          )
                        )
                      "
                      alt=""
                      class="pdf__content__column__campo__caracteristica__right__miniatura__image"
                    />
                  </div>
                  <div
                    class="pdf__content__column__campo__caracteristica__right__miniatura"
                    v-else-if="Campo.tipo == 'filtro'"
                  >
                    <img
                      crossOrigin="anonymous"
                      :src="
                        RequireImage(
                          'Tacos',
                          Campo.filtroSel.Delay.acabadoSel.taco
                        )
                      "
                      alt=""
                      class="pdf__content__column__campo__caracteristica__right__miniatura__image"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="pdf__content__column__campo"
              style="border-bottom: 1px solid black"
            >
              <h1 class="pdf__content__column__campo__title">
                {{
                  this.aplicacion.coleccionSel.sideSel.Live.GetGrupo("TIRADOR")
                    .cod
                }}
              </h1>
              <div
                v-for="(
                  Campo, CampoIndex
                ) in this.aplicacion.coleccionSel.sideSel.Live.GetGrupo(
                  'TIRADOR'
                ).campos"
                v-if="
                  Campo.Resolve(aplicacion.coleccionSel.sideSel.Delay.perfil) &&
                  Campo.visible &&
                  !(
                    Campo.cod == 'TIPO_VIDRIO' && Campo.acabadoSel.cod == '04'
                  ) &&
                  !(Campo.cod == 'COLOR_DECORADO' && Campo.tipo != 'filtro') &&
                  !(
                    Campo.cod == 'COLOR_PERFIL_ST' &&
                    Campo.acabadoSel.cod == 'RL'
                  )
                "
                class="pdf__content__column__campo__caracteristica"
              >
                <div class="pdf__content__column__campo__caracteristica__title">
                  {{ Campo.GetLiteral(aplicacion.languageSel) }}
                </div>
                <div class="pdf__content__column__campo__caracteristica__right">
                  <p
                    v-if="Campo.tipo == 'input'"
                    class="pdf__content__column__campo__caracteristica__right__value"
                    style="position: absolute; right: 100px"
                  >
                    {{ Campo.value }}
                  </p>
                  <p
                    v-else-if="
                      Campo.tipo == 'tacos' ||
                      Campo.tipo == 'dropdown' ||
                      Campo.tipo == 'toggle'
                    "
                    class="pdf__content__column__campo__caracteristica__right__value"
                    style="position: absolute; right: 100px"
                  >
                    {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                  </p>
                  <div
                    class="pdf__content__column__campo__caracteristica__right__miniatura"
                    v-if="Campo.tipo == 'tacos'"
                  >
                    <img
                      crossOrigin="anonymous"
                      :src="
                        RequireImage(
                          'Tacos',
                          aplicacion.coleccionSel.sideSel.Live.GetTaco(
                            Campo,
                            Campo.acabadoSel
                          )
                        )
                      "
                      alt=""
                      class="pdf__content__column__campo__caracteristica__right__miniatura__image"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="pdf__content__column__campo">
              <h1 class="pdf__content__column__campo__title">
                {{
                  this.aplicacion.coleccionSel.sideSel.Live.GetGrupo("PERFIL")
                    .cod
                }}
              </h1>
              <div
                v-for="(
                  Campo, CampoIndex
                ) in this.aplicacion.coleccionSel.sideSel.Live.GetGrupo(
                  'PERFIL'
                ).campos"
                v-if="
                  Campo.Resolve(aplicacion.coleccionSel.sideSel.Delay.perfil) &&
                  Campo.visible &&
                  !(
                    Campo.cod == 'TIPO_VIDRIO' && Campo.acabadoSel.cod == '04'
                  ) &&
                  !(Campo.cod == 'COLOR_DECORADO' && Campo.tipo != 'filtro') &&
                  !(
                    Campo.cod == 'COLOR_PERFIL_ST' &&
                    Campo.acabadoSel.cod == 'RL'
                  )
                "
                class="pdf__content__column__campo__caracteristica"
              >
                <div class="pdf__content__column__campo__caracteristica__title">
                  {{ Campo.GetLiteral(aplicacion.languageSel) }}
                </div>
                <div class="pdf__content__column__campo__caracteristica__right">
                  <p
                    v-if="Campo.tipo == 'input'"
                    class="pdf__content__column__campo__caracteristica__right__value"
                    style="position: absolute; right: 100px"
                  >
                    {{ Campo.value }}
                  </p>
                  <p
                    v-else-if="
                      Campo.tipo == 'tacos' ||
                      Campo.tipo == 'dropdown' ||
                      Campo.tipo == 'toggle'
                    "
                    class="pdf__content__column__campo__caracteristica__right__value"
                    style="position: absolute; right: 100px"
                  >
                    {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                  </p>
                  <div
                    class="pdf__content__column__campo__caracteristica__right__miniatura"
                    v-if="Campo.tipo == 'tacos'"
                  >
                    <img
                      crossOrigin="anonymous"
                      :src="
                        RequireImage(
                          'Tacos',
                          aplicacion.coleccionSel.sideSel.Live.GetTaco(
                            Campo,
                            Campo.acabadoSel
                          )
                        )
                      "
                      alt=""
                      class="pdf__content__column__campo__caracteristica__right__miniatura__image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pdf__content__column">
            <div
              v-if="
                !SetAdicionales(
                  aplicacion.coleccionSel.sideSel.Live.GetGrupo('ADICIONALES')
                )
              "
              class="pdf__content__column__campo"
            >
              <h1 class="pdf__content__column__campo__title">
                {{
                  this.aplicacion.coleccionSel.sideSel.Live.GetGrupo(
                    "ADICIONALES"
                  ).cod
                }}
              </h1>
              <div
                v-for="(
                  Campo, CampoIndex
                ) in this.aplicacion.coleccionSel.sideSel.Live.GetGrupo(
                  'ADICIONALES'
                ).campos"
                v-if="
                  Campo.Resolve(aplicacion.coleccionSel.sideSel.Delay.perfil) &&
                  Campo.visible &&
                  !(
                    Campo.cod == 'TIPO_VIDRIO' && Campo.acabadoSel.cod == '04'
                  ) &&
                  !(Campo.cod == 'COLOR_DECORADO' && Campo.tipo != 'filtro') &&
                  !(
                    Campo.cod == 'COLOR_PERFIL_ST' &&
                    Campo.acabadoSel.cod == 'RL'
                  )
                "
                class="pdf__content__column__campo__caracteristica"
                :style="CampoIndex == 0 ? '' : 'margin-top:20px'"
              >
                <div class="pdf__content__column__campo__caracteristica__left">
                  <p
                    class="pdf__content__column__campo__caracteristica__left__title"
                  >
                    {{ Campo.GetLiteral(aplicacion.languageSel) }}
                  </p>
                  <p
                    v-if="Campo.tipo == 'input'"
                    class="pdf__content__column__campo__caracteristica__left__value"
                  >
                    {{ Campo.value }}
                  </p>
                  <p
                    v-else-if="
                      Campo.tipo == 'tacos' ||
                      Campo.tipo == 'dropdown' ||
                      Campo.tipo == 'toggle'
                    "
                    class="pdf__content__column__campo__caracteristica__left__value"
                  >
                    {{ Campo.acabadoSel.GetLiteral(aplicacion.languageSel) }}
                  </p>
                </div>
                <div
                  v-if="
                    Campo.cod == 'PERFIL_ESCUADRA' ||
                    Campo.cod == 'PERFILERIA_ECO' ||
                    Campo.cod == 'SISTEMA_SUJECCION'
                  "
                  class="pdf__content__column__campo__caracteristica__miniatura"
                >
                  <img
                    crossOrigin="anonymous"
                    :src="
                      RequireImage(
                        'Tacos',
                        aplicacion.coleccionSel.sideSel.Live.GetTaco(
                          Campo,
                          Campo.acabadoSel
                        )
                      )
                    "
                    alt=""
                    class="pdf__content__column__campo__caracteristica__right__miniatura__image"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="aplicacion.montajeExists() && montaje.valor != 0"
              class="pdf__content__column__campo"
            >
              <h1 class="pdf__content__column__campo__title">
                {{
                  this.aplicacion.coleccionSel.sideSel.Live.GetGrupo("MONTAJE")
                    .cod
                }}
              </h1>
              <span class="pdf__content__column__campo__text">{{
                montaje.texto
              }}</span>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import Pricing from "@/components/Pricing.vue";
import VueHtml2pdf from "vue-html2pdf";
import axios from "axios";

export default {
  name: "Pdf",
  data() {
    return {
      montaje: "",
      Price: "",
      Message: "",
      separador: "&",
      separador2: "-",
      extension: "webp",
      images: new Array(),
    };
  },
  props: {
    viewprice: Boolean,
    privada: String,
    pdf: Boolean,
    aplicacion: Object,
    Coleccion: Object,
    Language: String,
    token: String,
  },
  components: {
    Pricing,
    VueHtml2pdf,
  },
  watch: {
    pdf: {
      handler(newVal) {
        if (newVal) {
          this.Imagen(
            this.aplicacion,
            this.aplicacion.coleccionSel.sideSel.Live
          );
          this.SetPrice();
          setTimeout(() => {
            this.$emit("setPdf", false);
          }, 350);
        }
      },
    },
  },
  methods: {
    /***/
    setMontaje(obj) {
      this.montaje = obj;
    },
    Imagen(aplicacion, side) {
      this.images = new Array();
      if (aplicacion.tipo == "estandar") {
        this.ImagenEstandar(aplicacion, side);
      } else {
        this.ImagenConfigurable(aplicacion, side);
      }
    },
    ImagenConfigurable(aplicacion, side) {
      var coleccion = aplicacion.colecciones[0];
      var archivo;
      var imagenes = new Set();

      var orden =
        coleccion.cod == "janeiro"
          ? {
              FONDO: 0,
              SUELO: 1,
              PARED: 2,
              POMO_ST_2: 3,
              COLOR_PERFIL_ST: 4,
              TIPO_VIDRIO: 5,
              DECORADO: 6,
              POMO_ST_1: 7,
            }
          : {
              FONDO: 0,
              SUELO: 1,
              PARED: 2,
              POMO_ST_2: 3,
              TIPO_VIDRIO: 4,
              ACRILICO: 5,
              DECORADO: 6,
              POMO_ST_1: 7,
              COLOR_PERFIL_ST: 8,
            };

      function NImagenes(coleccion, campo) {
        var ret = 1;
        if (campo == "POMO_ST") {
          ret = 2;
        }
        return ret;
      }

      var prefijo = "";
      if (coleccion.cod.toUpperCase() == "MINDANAO") {
        var campoOpciones = side.GetCampo("OPCIONES_MINDANAO");
        //console.log(campoOpciones);
        switch (campoOpciones.acabadoSel.cod) {
          case "00":
            prefijo = "_PERFILAPARED";
            break;
          case "01":
            prefijo = "_PERFILADAENMARCADA";
            break;
          case "02":
            prefijo = "_COZUMEL";
            break;
          case "03":
            prefijo = "_BARBADOS";
            break;
          case "04":
            prefijo = "_MARTINICA";
            break;
          default:
            break;
        }
      }

      let coleccionCod = coleccion.codImage;

      imagenes.add({
        orden: orden["FONDO"],
        archivo:
          coleccionCod + prefijo + this.separador + "FONDO." + this.extension,
        img: Image,
      });

      side.grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          // //console.log(campo.cod, campo.esCapa, campo.visual,campo.GetLiteral("es"));
          if (side.ResolveCondicion(campo.condicion)) {
            if (campo.esCapa) {
              // Si el campo es compuesto la capa se forma con los códigos del campo y el campo compuesto
              if (campo.compuesto != undefined) {
                // HARDCODE 2: Imágenes dobles
                const nImagenes = NImagenes(coleccion.cod, campo.cod);
                // HARDCODE 2: Imágenes dobles
                const baseArchivo =
                  coleccion.codImage +
                  prefijo +
                  this.separador +
                  grupo.cod +
                  this.separador +
                  campo.cod +
                  this.separador2 +
                  campo.compuesto.cod +
                  this.separador +
                  this.TransformaAcabado(campo.acabadoSel.cod) +
                  this.separador2 +
                  campo.compuesto.acabadoSel.cod;

                if (nImagenes > 1) {
                  // Generar y agregar las imágenes
                  for (let i = 0; i < nImagenes; i++) {
                    archivo =
                      baseArchivo +
                      this.separador +
                      (nImagenes === 1 ? "" : i + 1) +
                      "." +
                      this.extension;
                    imagenes.add({
                      orden: orden[campo.cod + "_" + (i + 1)],
                      archivo: archivo,
                      img: Image,
                    });
                  }
                } else {
                  archivo = baseArchivo + "." + this.extension;
                  imagenes.add({
                    orden: orden[campo.cod],
                    archivo: archivo,
                    img: Image,
                  });
                }
              } else {
                if (campo.acabadoSel.compuesto == undefined) {
                  //archivo = campo.acabadoSel.capa;
                  // Es dinámico
                  archivo =
                    coleccion.codImage +
                    prefijo +
                    this.separador +
                    grupo.cod +
                    this.separador +
                    campo.cod +
                    this.separador +
                    campo.acabadoSel.cod +
                    "." +
                    this.extension;
                } else {
                  archivo =
                    coleccion.codImage +
                    prefijo +
                    this.separador +
                    grupo.cod +
                    this.separador +
                    campo.cod +
                    this.separador2 +
                    campo.acabadoSel.compuesto.cod +
                    this.separador +
                    campo.acabadoSel.cod +
                    this.separador2 +
                    campo.acabadoSel.compuesto.acabadoSel.cod +
                    "." +
                    this.extension;
                }
                imagenes.add({
                  orden: orden[campo.cod],
                  archivo: archivo,
                  img: Image,
                });
              }
            }
          }
        });
      });

      // Convertir a array
      imagenes = [...imagenes];

      imagenes = imagenes.sort(function (a, b) {
        return a.orden - b.orden;
      });

      var that = this;
      var imagenesPGN = [];
      var counter = 0;
      imagenes.forEach((ImageEl) => {
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.src = that.RequireImage(ImageEl.archivo);
        img.onload = function () {
          counter++;
          ImageEl.img = img;
          imagenesPGN.push({
            el: ImageEl,
            img: img,
          });
          if (counter == imagenes.length) {
            that.DibujaEscena(imagenes, side);
          }
        };
      });
    },
    ImagenEstandar(aplicacion, side) {
      var coleccion = aplicacion.colecciones[0];
      var archivo;
      var imagenes = new Set();

      var orden = {
        FONDO: 0,
        SUELO: 1,
        PARED: 2,
        POMO_ST_2: 3,
        TIPO_VIDRIO: 4,
        DECORADO: 5,
        POMO_ST_1: 6,
        COLOR_PERFIL_ST: 7,
      };

      function NImagenes(coleccion, campo) {
        var ret = 1;
        if (campo == "tirador") {
          ret = 2;
        }
        return ret;
      }

      var prefijo = "";
      let coleccionCod = coleccion.codImage;

      if (coleccion.codImage == "MINDANAO") {
        prefijo = "_PERFILAPARED";
      }

      imagenes.add({
        orden: orden["FONDO"],
        archivo:
          coleccionCod + prefijo + this.separador + "FONDO." + this.extension,
        img: Image,
      });

      side.grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          if (side.ResolveCondicion(campo.condicion)) {
            if (campo.esCapa) {
              let campoCod, campoCompuestoCod, acabadoCod, acabadoCompuestoCod;
              // Si el campo es compuesto la capa se forma con los códigos del campo y el campo compuesto
              if (campo.compuesto != undefined) {
                // HARDCODE 2: Imágenes dobles
                const nImagenes = NImagenes(coleccionCod, campo.cod);
                // HARDCODE 2: Imágenes dobles
                if (campo.cod == "tirador") {
                  campoCod = "POMO_ST";
                  campoCompuestoCod = "COLOR_PERFIL_ST";
                }

                acabadoCod = campo.acabadoSel.cod;
                acabadoCompuestoCod = campo.compuesto.acabadoSel.cod;
                if (!isNaN(parseInt(acabadoCod))) {
                  acabadoCod = acabadoCod.padStart(2, "0");
                }
                if (!isNaN(parseInt(acabadoCompuestoCod))) {
                  acabadoCompuestoCod = acabadoCompuestoCod.padStart(2, "0");
                }

                const baseArchivo =
                  coleccionCod +
                  prefijo +
                  this.separador +
                  grupo.cod +
                  this.separador +
                  campoCod +
                  this.separador2 +
                  campoCompuestoCod +
                  this.separador +
                  acabadoCod +
                  this.separador2 +
                  acabadoCompuestoCod;

                if (nImagenes > 1) {
                  // Generar y agregar las imágenes
                  for (let i = 0; i < nImagenes; i++) {
                    archivo =
                      baseArchivo +
                      this.separador +
                      (nImagenes === 1 ? "" : i + 1) +
                      "." +
                      this.extension;
                    imagenes.add({
                      orden: orden[campoCod + "_" + (i + 1)],
                      archivo: archivo,
                      img: Image,
                    });
                  }
                } else {
                  archivo = baseArchivo + "." + this.extension;
                  imagenes.add({
                    orden: orden[campoCod],
                    archivo: archivo,
                    img: Image,
                  });
                }
              } else {
                if (campo.acabadoSel.compuesto != undefined) {
                  // Transforma código (sólo existe el campo perfil con esta condición)
                  // Este sólo puede ser el campo "vidrio"
                  // 1.- Añade la capa TIPO_VIDRIO - PARED
                  campoCod = "TIPO_VIDRIO";
                  campoCompuestoCod = "PARED";
                  acabadoCod = campo.acabadoSel.cod;
                  acabadoCompuestoCod =
                    campo.acabadoSel.compuesto.acabadoSel.cod;
                  if (!isNaN(parseInt(acabadoCod))) {
                    acabadoCod = acabadoCod.padStart(2, "0");
                  }
                  if (!isNaN(parseInt(acabadoCompuestoCod))) {
                    acabadoCompuestoCod = acabadoCompuestoCod.padStart(2, "0");
                  }
                  if (acabadoCod == "00") {
                    // Incoloro 01
                    acabadoCod = "01";
                  } else {
                    // Decorado 04
                    acabadoCod = "04";
                  }

                  archivo =
                    coleccionCod +
                    prefijo +
                    this.separador +
                    grupo.cod +
                    this.separador +
                    campoCod +
                    this.separador2 +
                    campoCompuestoCod +
                    this.separador +
                    acabadoCod +
                    this.separador2 +
                    acabadoCompuestoCod +
                    "." +
                    this.extension;
                  imagenes.add({
                    orden: orden[campoCod],
                    archivo: archivo,
                    img: Image,
                  });
                  // 2.- Añade la capa DECORADO - COLOR_DECORADO
                  if (acabadoCod == "04") {
                    campoCod = "DECORADO";
                    campoCompuestoCod = "COLOR_DECORADO";
                    acabadoCod = campo.acabadoSel.cod;
                    if (!isNaN(parseInt(acabadoCod))) {
                      acabadoCod = acabadoCod.padStart(2, "0");
                    }

                    // Siempre es en color blanco...
                    acabadoCompuestoCod = "01";
                    // Excepto...
                    if (coleccionCod == "MINDANAO") {
                      if (acabadoCod == "38") {
                        acabadoCompuestoCod = "02";
                      }
                    }

                    archivo =
                      coleccionCod +
                      prefijo +
                      this.separador +
                      grupo.cod +
                      this.separador +
                      campoCod +
                      this.separador2 +
                      campoCompuestoCod +
                      this.separador +
                      acabadoCod +
                      this.separador2 +
                      acabadoCompuestoCod +
                      "." +
                      this.extension;
                    imagenes.add({
                      orden: orden[campoCod],
                      archivo: archivo,
                      img: Image,
                    });
                  }
                } else {
                  // Transforma código (sólo existe el campo perfil con esta condición)
                  if (campo.cod == "perfil") {
                    campoCod = "COLOR_PERFIL_ST";
                  } else {
                    campoCod = campo.cod;
                  }
                  acabadoCod = campo.acabadoSel.cod;
                  if (!isNaN(parseInt(acabadoCod))) {
                    acabadoCod = acabadoCod.padStart(2, "0");
                  }
                  archivo =
                    coleccionCod +
                    prefijo +
                    this.separador +
                    grupo.cod +
                    this.separador +
                    campoCod +
                    this.separador +
                    acabadoCod +
                    "." +
                    this.extension;
                  imagenes.add({
                    orden: orden[campoCod],
                    archivo: archivo,
                    img: Image,
                  });
                }
              }
            }
          }
        });
      });

      // Convertir a array
      imagenes = [...imagenes];

      imagenes = imagenes.sort(function (a, b) {
        return a.orden - b.orden;
      });
      //console.table(imagenes);

      var that = this;
      var imagenesPGN = [];
      var counter = 0;
      imagenes.forEach((ImageEl) => {
        var img = new Image();
        img.src = that.RequireImage(ImageEl.archivo);
        img.onload = function () {
          counter++;
          ImageEl.img = img;
          imagenesPGN.push({
            el: ImageEl,
            img: img,
          });
          if (counter == imagenes.length) {
            that.DibujaEscena(imagenes, side);
          }
        };
      });
    },
    TransformaAcabado(acabadoCod) {
      let cod;
      if (!isNaN(parseInt(acabadoCod))) {
        cod = acabadoCod.padStart(2, "0");
      } else {
        cod = acabadoCod;
      }
      return cod;
    },
    DibujaEscena(imagenes, side) {
      imagenes.forEach((image) => {
        this.images.push(image.archivo);
      });
    },
    /***/
    removePageBreaks() {
      // Ensure the ref is available
      if (this.$refs.pdfContent) {
        // Select all elements with the class 'html2pdf__page-break'
        const pageBreakElements = this.$refs.pdfContent.querySelectorAll(
          ".html2pdf__page-break"
        );

        // Remove each page break element from the DOM
        pageBreakElements.forEach((element) => {
          element.parentNode.removeChild(element);
        });

        //console.log("All page breaks removed.");
      } else {
        //console.warn("pdfContent ref not found.");
      }
    },
    SetAdicionales(Grupo) {
      var status = false;
      status = Grupo.campos.every(
        (campo) =>
          campo.visible === false ||
          campo.Resolve(this.aplicacion.coleccionSel.sideSel.Live.perfil) ===
            false
      );
      if (status) {
        if (Grupo.cod == this.aplicacion.grupoSel.Live.cod) {
          this.SetGrupo(this.aplicacion.coleccionSel.sideSel.Live.grupos[0]);
        }
      }
      return status;
    },
    ResolveImage(e) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }
      element.parentNode.classList.remove("skeleton");

      setTimeout(() => {
        element.style.opacity = 1;
        var Detalle = element.parentNode.parentNode.children[0];
        if (
          Detalle.classList.contains(
            "menu__caracteristicas__campos__item__acabados__items__item__detalle"
          )
        ) {
          Detalle.style.opacity = 1;
        }
      }, 50);
    },
    RequireImage(Folder, url) {
      var Image;
      try {
        Image = require("@/assets/Images/" + Folder + "/" + url);
      } catch (error) {
        //console.log("%c" + Folder + "/" + url, "color:red");
        Image = require("@/assets/Images/Global/Error.webp");
      }
      return Image;
    },
    SetAdicionales(Grupo) {
      var status = false;
      status = Grupo.campos.every(
        (campo) =>
          campo.visible === false ||
          campo.Resolve(this.aplicacion.coleccionSel.sideSel.Live.perfil) ===
            false
      );
      if (status) {
        if (Grupo.cod == this.aplicacion.grupoSel.Live.cod) {
          this.SetGrupo(this.aplicacion.coleccionSel.sideSel.Live.grupos[0]);
        }
      }
      return status;
    },
    ResolveCondicion(id, Condicion) {
      var Status = true;

      if (Condicion != "" && Condicion != undefined) {
        try {
          var perfil = this.aplicacion.coleccionSel.sideSel.Live.perfil;
          Status = eval(Condicion);
        } catch (error) {
          //console.log(error);
          //console.log(id);
          //console.log(Condicion);
        }
      }

      return Status;
    },
    findDifferences(json1, json2) {
      const json1Map = new Map();
      const json2Map = new Map();

      // Convertir json1 y json2 en mapas para una búsqueda rápida por id
      json1.forEach((item) => json1Map.set(item.id, item));
      json2.forEach((item) => json2Map.set(item.id, item));

      const differences = [];

      // Función para comparar dos objetos y encontrar diferencias
      function compareObjects(obj1, obj2) {
        const diffs = {};
        const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

        keys.forEach((key) => {
          if (obj1[key] !== obj2[key]) {
            diffs[key] = { value1: obj1[key], value2: obj2[key] };
          }
        });

        return Object.keys(diffs).length > 0 ? diffs : null;
      }

      // Comparar los elementos de json1 con json2
      json1Map.forEach((item1, id) => {
        const item2 = json2Map.get(id);
        if (item2) {
          const diffs = compareObjects(item1, item2);
          if (diffs) {
            differences.push({ id, differences: diffs });
          }
          json2Map.delete(id); // Eliminar el id de json2Map una vez comparado
        } else {
          differences.push({
            id,
            differences: { value1: item1, value2: null },
          });
        }
      });

      // Los elementos restantes en json2Map no están en json1
      json2Map.forEach((item2, id) => {
        differences.push({ id, differences: { value1: null, value2: item2 } });
      });

      return differences;
    },
    SetPrice() {
      if (this.aplicacion.tipo == "configurable") {
        this.Message =
          this.aplicacion.languageSel == "es"
            ? "Envío en 7 días (laborables)"
            : this.aplicacion.languageSel == "en"
            ? "Shipping in 7 (working) days"
            : this.aplicacion.languageSel == "fr"
            ? "Livraison en 7 jours ouvrables"
            : this.aplicacion.languageSel == "de"
            ? "Versand in 7 Werktagen"
            : this.aplicacion.languageSel == "it"
            ? "Spedizione in 7 giorni lavorativi"
            : "Envio em 7 dias úteis";
        var Price = new Object();
        Price.caracteristicas = new Array();
        Price.codigo = this.aplicacion.coleccionSel.cod.toUpperCase();
        Price.posiciones = new Array();
        var Posicion = new Object();
        Posicion.cantidad = 1;
        Posicion.material = this.aplicacion.coleccionSel.cod.toUpperCase();
        Posicion.posLm = "";
        Posicion.posicion = 10;
        Price.posiciones.push(Posicion);
        this.aplicacion.coleccionSel.sideSel.Live.grupos.forEach((Grupo) => {
          Grupo.campos.forEach((CaracteristicaEl) => {
            if (
              this.ResolveCondicion(
                CaracteristicaEl.cod,
                CaracteristicaEl.condicion
              ) &&
              CaracteristicaEl.cod != "SUELO" &&
              CaracteristicaEl.cod != "PARED"
            ) {
              var Caracteristica = new Object();
              Caracteristica.id = CaracteristicaEl.id;
              //Caracteristica.name = CaracteristicaEl.cod;
              // El COLOR_PERFIL se vuelve a transformaR en COLOR_PERFIL_ST

              if (CaracteristicaEl.cod == "COLOR_PERFIL_ST") {
                let cambio =
                  this.aplicacion.datosConfigurable.caracteristicas.filter(
                    (caracteristica) => caracteristica.codigo == "COLOR_PERFIL"
                  );
                if (cambio.length == 1) {
                  Caracteristica.name = "COLOR_PERFIL";
                } else {
                  Caracteristica.name = "COLOR_PERFIL_ST";
                }
                //console.log(Caracteristica.name);
              } else if (CaracteristicaEl.cod == "POMO_ST") {
                let cambio =
                  this.aplicacion.datosConfigurable.caracteristicas.filter(
                    (caracteristica) => caracteristica.codigo == "POMO"
                  );
                if (cambio.length == 1) {
                  Caracteristica.name = "POMO";
                } else {
                  Caracteristica.name = "POMO_ST";
                }
              } else {
                Caracteristica.name = CaracteristicaEl.cod;
              }

              Caracteristica.value =
                CaracteristicaEl.tipo == "input"
                  ? CaracteristicaEl.value
                  : CaracteristicaEl.acabadoSel.cod;
              Caracteristica.posicion = 10;
              // Caracteristica.human = {
              //   label: CaracteristicaEl.GetLiteral(this.aplicacion.languageSel),
              //   value:
              //     CaracteristicaEl.tipo == "input"
              //       ? CaracteristicaEl.value
              //       : CaracteristicaEl.acabadoSel.GetLiteral(
              //           this.aplicacion.languageSel
              //         ),
              // };
              Caracteristica.error = false;

              Price.caracteristicas.push(Caracteristica);
            }
          });
        });
        // Se genera un id para la petición y se guarda el último. Si una petición es lenta y otra
        // se adelanta, la petición lenta se desecha, para no poner un precio erróneo
        Price.id = Math.floor(Math.random() * 1000000000);
        this.lastPriceId = Price.id;
        //console.log("Petición", Price.id);
        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://clients.docciagroup.com/api/renders/precio-configurable",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.token,
          },
          data: Price,
        };

        axios
          .request(config)
          .then((response) => {
            // Sólo debe actualizar la última petición, si una petición tarda mucho y otra
            // se adelanta, la petición lenta se desecha, para no poner un precio erróneo
            if (this.lastPriceId != Price.id) {
              return;
            }

            this.Error = false;
            //console.log(response.data.precio);
            if (response.data.precio == 0) {
              this.Error = true;
            }
            this.Price = {
              precio: Number.isInteger(response.data.precio)
                ? response.data.precio.toString()
                : response.data.precio.toFixed(2),
              precioFijo: response.data.precioFijo,
              moneda: response.data.moneda,
              codigoPostal: response.data.distribuidor.codigoPostal,
              direccion: response.data.distribuidor.direccion,
              email: response.data.distribuidor.email,
              id: response.data.distribuidor.id,
              isoPais: response.data.distribuidor.isoPais,
              localidad: response.data.distribuidor.localidad,
              nombre: response.data.distribuidor.nombre,
              telefono: response.data.distribuidor.telefono,
            };
            this.Price.moneda = "€";
            this.Loading = false;
            this.LoadingEnvio = false;

            Price.configurable = true;
            Price.material = this.aplicacion.datosConfigurable.material;
            Price.moneda = "EUR";
            Price.precio = Number.isInteger(response.data.precio)
              ? response.data.precio.toString()
              : response.data.precio.toFixed(2);
            // Actualiza el objeto aplicacion
            this.aplicacion.coleccionSel.sideSel.Live.priceObj = Price;
            this.removePageBreaks();
            this.$refs.html2Pdf.generatePdf();
          })
          .catch((error) => {
            //console.log(error);
          });
      } else {
        var codigo = this.aplicacion.GetCodigoEstandar();

        if (codigo == "ERROR") {
          this.Error = true;
          this.Loading = false;
          return;
        }

        let config = {
          method: "get",
          maxBodyLength: Infinity,
          url:
            "https://clients.docciagroup.com/api/renders/precio-estandar?codigo=" +
            codigo,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.token,
          },
        };
        axios
          .request(config)
          .then((response) => {
            this.aplicacion.languageSel == "es"
              ? (this.Message =
                  response.data.stock == 0
                    ? "Envío en 4-5 días (laborables)"
                    : "Envío en 24-48 horas")
              : this.aplicacion.languageSel == "en"
              ? (this.Message =
                  response.data.stock == 0
                    ? "Shipping in 4-5 (working) days"
                    : "Shipping in 24-48 hours")
              : this.aplicacion.languageSel == "fr"
              ? (this.Message =
                  response.data.stock == 0
                    ? "Livraison en 4-5 jours ouvrables"
                    : "Livraison en 24-48 heures")
              : this.aplicacion.languageSel == "de"
              ? (this.Message =
                  response.data.stock == 0
                    ? "Versand in 4-5 Werktagen"
                    : "Versand in 24-48 Stunden")
              : this.aplicacion.languageSel == "it"
              ? (this.Message =
                  response.data.stock == 0
                    ? "Spedizione in 4-5 giorni lavorativi"
                    : "Spedizione in 24-48 ore")
              : (this.Message =
                  response.data.stock == 0
                    ? "Envio em 4-5 dias úteis"
                    : "Envio em 24-48 horas");
            this.Error = false;
            //console.log(response.data.precio);
            if (response.data.precio == 0) {
              this.Error = true;
              //console.log("No existe ese código");
            }
            this.Price = {
              precio: Number.isInteger(response.data.precio)
                ? response.data.precio.toString()
                : response.data.precio.toFixed(2),
              precioFijo: response.data.precioFijo,
              moneda: response.data.moneda,
              codigoPostal: response.data.distribuidor.codigoPostal,
              direccion: response.data.distribuidor.direccion,
              email: response.data.distribuidor.email,
              id: response.data.distribuidor.id,
              isoPais: response.data.distribuidor.isoPais,
              localidad: response.data.distribuidor.localidad,
              nombre: response.data.distribuidor.nombre,
              telefono: response.data.distribuidor.telefono,
            };
            this.Price.moneda = "€";

            var side = this.aplicacion.coleccionSel.sideSel.Live;
            var caracteristicas = this.aplicacion.datosEstandar.caracteristicas;
            var campo;
            var priceObj = side.priceObj;

            // Actualiza el objeto del precio del side
            priceObj.precio = Number.isInteger(response.data.precio)
              ? response.data.precio.toString()
              : response.data.precio.toFixed(2);
            priceObj.id = response.data.id;
            priceObj.moneda = response.data.moneda;
            priceObj.codigo = codigo;
            priceObj.configurable = false;
            priceObj.caracteristicas = [];

            for (const clave in caracteristicas) {
              if (caracteristicas.hasOwnProperty(clave)) {
                campo = side.GetCampo(clave);
                priceObj.caracteristicas.push({
                  human: {
                    label: clave,
                    value: campo.acabadoSel.GetLiteral(
                      this.aplicacion.languageSel
                    ),
                  },
                });
              }
            }
            // Actualiza objeto price del side
            side.priceObj = priceObj;

            this.Loading = false;
            this.LoadingEnvio = false;
            this.removePageBreaks();
            this.$refs.html2Pdf.generatePdf();
          })
          .catch((error) => {
            this.Error = true;
            this.Loading = false;
            this.LoadingEnvio = false;
            //console.log(error);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pdf {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    width: 100%;
    height: calc($Header-height + 25px);
    padding: 0px 25px;
    background-color: white;
    -webkit-transition: background-color 0.35s ease-in-out;
    -moz-transition: background-color 0.35s ease-in-out;
    -ms-transition: background-color 0.35s ease-in-out;
    -o-transition: background-color 0.35s ease-in-out;
    transition: background-color 0.35s ease-in-out;
    &__info {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
      height: 100%;
      &__logo {
        filter: invert(0%) brightness(100%);
        height: 30px;
        -webkit-transition: filter 0.35s ease-in-out;
        -moz-transition: filter 0.35s ease-in-out;
        -ms-transition: filter 0.35s ease-in-out;
        -o-transition: filter 0.35s ease-in-out;
        transition: filter 0.35s ease-in-out;
      }
      &__separator {
        pointer-events: none;
        height: 40%;
        width: 0.1em;
        background-color: black;
        margin: 0px 15px;
        -webkit-transition: background-color 0.35s ease-in-out;
        -moz-transition: background-color 0.35s ease-in-out;
        -ms-transition: background-color 0.35s ease-in-out;
        -o-transition: background-color 0.35s ease-in-out;
        transition: background-color 0.35s ease-in-out;
      }
      &__collection {
        text-transform: capitalize;
        color: black;
        font-size: 25px;
        line-height: 25px;
        font-weight: 400;
        text-transform: capitalize;
        -webkit-transition: color 0.35s ease-in-out;
        -moz-transition: color 0.35s ease-in-out;
        -ms-transition: color 0.35s ease-in-out;
        -o-transition: color 0.35s ease-in-out;
        transition: color 0.35s ease-in-out;
      }
      &__configuration {
        text-transform: capitalize;
        color: black;
        font-size: 18px;
        line-height: 25px;
        margin-top: 5px;
        font-weight: 400;
        margin-left: 20px;
        text-transform: capitalize;
        -webkit-transition: color 0.35s ease-in-out;
        -moz-transition: color 0.35s ease-in-out;
        -ms-transition: color 0.35s ease-in-out;
        -o-transition: color 0.35s ease-in-out;
        transition: color 0.35s ease-in-out;
      }
      &__separator {
        pointer-events: none;
        height: 40%;
        width: 0.1em;
        background-color: black;
        margin: 0px 15px;
        -webkit-transition: background-color 0.35s ease-in-out;
        -moz-transition: background-color 0.35s ease-in-out;
        -ms-transition: background-color 0.35s ease-in-out;
        -o-transition: background-color 0.35s ease-in-out;
        transition: background-color 0.35s ease-in-out;
      }
    }
    &__data {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      width: 400px;
      &__item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        width: 100%;
        color: black;
        font-size: 10px;
        line-height: 10px;
        &:not(:first-child) {
          margin-top: 2.5px;
        }
      }
    }
  }
  &__image {
    position: relative;
    width: 100%;
    height: auto;
    background-repeat: no-repeat;
    background-size: cover;
    &__price {
      color: black;
      position: absolute;
      bottom: 0;
      left: 0;
      transform: translate(-145px, 0%);
      height: 180px;
      width: 400px;
      border-radius: 200px 400px 0 0;
      background-color: rgba(255, 255, 255, 1);
      z-index: 10000000;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding-left: 171px;
      padding-top: 25px;
      padding-top: 35px;
      &__title {
        margin-bottom: 10px;
      }
      &__price {
        font-size: 30px;
        line-height: 40px;
        letter-spacing: -1px;
      }
      &__items {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 2px;
        margin-bottom: 10px;
        &__item {
          font-size: 11px;
          line-height: 11px;
        }
      }
      &__envio {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        &__icon {
          opacity: 1;
          height: 15px;
          margin-right: 10px;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }
        &__text {
          opacity: 1;
          position: absolute;
          white-space: nowrap;
          font-size: 10px;
          line-height: 10px;
          margin-left: 25px;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }
      }
    }
    &__images {
      position: relative;
      width: 100%;
      height: 455px;
      &__image {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  &__content {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 10px 25px;
    z-index: 10000000000;
    &__column {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      height: 100%;
      padding: 0px 25px;
      &__campo {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        height: auto;
        padding: 20px 0px;
        position: relative;
        min-height: calc(40px + 80px);
        &__title {
          color: black;
          font-weight: 600;
          font-size: 16px;
          line-height: 16px;
          margin-bottom: 5px;
        }
        &__caracteristica {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: flex-start;
          width: 100%;
          height: auto;
          &:not(:first-child) {
            margin-top: 8px;
          }
          &__title {
            color: black;
            font-weight: 300;
            font-size: 12px;
            line-height: 12px;
            opacity: 0.75;
          }
          &__right {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: flex-start;
            &__value {
              color: black;
              font-weight: 600;
              font-size: 12px;
              line-height: 12px;
              white-space: nowrap;
            }
            &__miniatura {
              position: absolute;
              top: 20px;
              width: 80px;
              height: 80px;
              border-radius: 5px;
              &__image {
                width: 100%;
                height: 100%;
                border-radius: 5px;
                object-fit: contain;
              }
            }
          }
          &__left {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            &__title {
              color: black;
              font-weight: 300;
              font-size: 12px;
              line-height: 12px;
              opacity: 0.75;
            }
            &__value {
              color: black;
              font-weight: 600;
              font-size: 12px;
              line-height: 12px;
              white-space: nowrap;
              margin-top: 5px;
            }
          }
          &__miniatura {
            width: 80px;
            height: 80px;
            border-radius: 5px;
            &__image {
              width: 100%;
              height: 100%;
              border-radius: 5px;
              object-fit: contain;
            }
          }
        }
        &__text {
          font-size: 16px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>

<style>
.vue-html2pdf .layout-container {
  left: revert !important;
}
</style>
